import { MapTo } from '@adobe/aem-react-editable-components';
import Newsfeed, { NewsfeedEditConfig } from './Newsfeed';

export default MapTo('cob-corp-acquisition/components/creditonebank/newsfeed')(Newsfeed, NewsfeedEditConfig);